import { render, staticRenderFns } from "./LomEdit.vue?vue&type=template&id=a81653c2"
import script from "./LomEdit.vue?vue&type=script&lang=js"
export * from "./LomEdit.vue?vue&type=script&lang=js"
import style0 from "./LomEdit.vue?vue&type=style&index=0&id=a81653c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports